angular.module('app').controller('colorLegalController',
  ['$scope', function (scope) {

  }]);
